/*
  Represents a single account row in the group editor
  Is reponsible for:
    creating and maintaining the DOM elements
    grabbing the account's details from the server (account type, credit)
*/


class GroupAccount {

  constructor({onChange=()=>{}, isEmailUnique=()=>true, signedInUser=null, email='', checked=false, isAdmin=false} = {}) {


    // properties
    this.props = {
      onChange,
      isEmailUnique,
      signedInUser,
    }

    // state 
    this.state = {
      isEditing: false,
      value: email,
      checked,
      isAdmin,

      // values fetched from server
      credit: 0,
      exists: null,
      isGroupMember: null,
      isGroupAdmin: null,
      isExpired: null,
    }

    this.getRemoteAccountDetails();
  }

  get email() {
    return this.state.value;
  }

  domElement() {
    if( this._domElement ) return this._domElement;
    this._domElement = this.createDomElement();
    return this._domElement;
  }

  createDomElement() {
    const domElement = document.createElement('tr');
    domElement.className = 'GroupAccount';
    domElement.innerHTML = `
      <td class="GroupAccount-account">
        <input class="GroupAccount-value" type="checkbox" name="accounts[]" value="${this.state.value.replace(/["<>]/g, '')}" ${this.state.checked && 'checked'} />
        <span class="GroupAccount-email">${this.prettyEmail()}</span>
      </td>
      <td class="GroupAccount-status">
        ${this.prettyStatus()}
      </td>
      <td class="GroupAccount-credit">
        ${this.prettyCredit()}
      </td>
      <td>
        <input class="GroupAccount-isAdmin" type="radio" name="admin" value="${this.state.value.replace(/["<>]/g, '')}" ${this.state.isAdmin && 'checked'} />
      </td>
    `;

    this.elAccount = domElement.querySelector('.GroupAccount-account');

    this.elLabel = domElement.querySelector('.GroupAccount-email');
    this.elLabel.addEventListener('click', e=>this.editEmail(e));

    this.elSelected = domElement.querySelector('.GroupAccount-value');
    this.elSelected.addEventListener('click', e=>this.updateValues(e));

    this.elStatus = domElement.querySelector('.GroupAccount-status');
    this.elCredit = domElement.querySelector('.GroupAccount-credit');

    this.elIsAdmin = domElement.querySelector('.GroupAccount-isAdmin');
    this.elIsAdmin.addEventListener('click', e=>this.updateValues(e));

    return domElement;
  }

  updateDomElement() {
    if( !this._domElement ) return;

    const { elAccount, elLabel, elSelected, elStatus, elCredit, elIsAdmin } = this;

    elLabel.innerHTML = this.prettyEmail();
    elSelected.value = this.state.value;
    elSelected.checked = this.state.checked;
    elStatus.innerText = this.prettyStatus();
    elCredit.innerText = this.prettyCredit();
    elIsAdmin.value = this.state.value;
    elIsAdmin.checked = this.state.isAdmin;

    const elAccountInput = (this.accountInput && this.accountInput.domElement());
    if( this.state.isEditing ) {
      if( elAccountInput && elAccount.contains(elLabel) ) elAccount.replaceChild( elAccountInput, elLabel);
    } else {
      if( elAccountInput && elAccount.contains(elAccountInput) ) elAccount.replaceChild( elLabel, elAccountInput );
    }


  }

  editEmail(e) {
    this.accountInput = new AccountInput({
      initialValue: this.state.value,
      isEmailUniqueCallback: (email) => this.props.isEmailUnique(email, this),
      finishedEditingCallback: this.inputFinished.bind(this),
    })
    this.state.isEditing = true;
    this.updateDomElement()
    this.accountInput.input.focus();
    this.accountInput.input.select();
  }

  inputFinished(value) {
    if( value != this.state.value ) {
      // when the email address changes
      this.state.value = value;

      // reset server values
      this.state.credit = 0;
      this.state.exists = null;
      this.state.isGroupMember = null;
      this.state.isGroupAdmin = null;
      this.state.isExpired = null;

      this.props.onChange(this, 'user');
      this.getRemoteAccountDetails();
    }

    // remove input and put back label
    this.state.isEditing = false;

    this.updateDomElement();
  }

  updateValues() {
    // when a checkbox or radio button changes
    this.state.isAdmin = this.elIsAdmin.checked;
    this.state.checked = this.elSelected.checked;
    this.props.onChange(this, 'user');
  }

  getRemoteAccountDetails() {
    if( !this.state.value ) return;

    // users can only check accounts with the same domain as them
    if( this.domainFor(this.state.value) !== this.domainFor(this.props.signedInUser) ) return;

    const xhr = new XMLHttpRequest();
    xhr.open('GET', `https://api2.activeinboxhq.com/1.0/validate/account/${this.state.value}`);
    xhr.setRequestHeader('x-aibuser', this.props.signedInUser);
    xhr.responseType = 'json';
    xhr.onload = () => {
      const {success, exists, is_group_member, is_group_admin, credit, is_expired} = xhr.response;
      if( success ) {
        this.state.exists = exists;
        this.state.isGroupMember = is_group_member;
        this.state.isGroupAdmin = is_group_admin;
        this.state.credit = credit;
        this.state.isExpired = is_expired;
        this.updateDomElement();
        this.props.onChange(this, 'server');
      }
    }
    xhr.send();
  }


  prettyStatus() {
    if( !this.state.exists ) {
      return '-';
    }
    return this.state.isExpired ? 'Trial Finished' : 'Active';
  }

  prettyCredit() {
    const prettyCredit = Math.round(this.state.credit * 100) / 100;
    return this.state.credit ? '$'+prettyCredit : '-';
  }

  prettyEmail() {
    return this.state.value.replace(/["<>]/g, '') || '<small>Available (click to add email address)</small>'
  }

  domainFor(email) {
    return email.replace(/.*@/, "");
  }

  // expose some state publicly (read only)
  get isAdmin() {
    return this.state.isAdmin;
  }

  get value() {
    return this.state.value;
  }

  get checked() {
    return this.state.checked;
  }

  get credit() {
    return this.state.credit;
  }

  get isGroupAdmin() {
    return this.state.isGroupAdmin;
  }

  // this can be set externally
  set isAdmin(value) {
    this.state.isAdmin = value;
  }
}
